/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsEntryFileResponse } from './RevisdomAPIViewModelsEntryFileResponse';
import {
    RevisdomAPIViewModelsEntryFileResponseFromJSON,
    RevisdomAPIViewModelsEntryFileResponseFromJSONTyped,
    RevisdomAPIViewModelsEntryFileResponseToJSON,
    RevisdomAPIViewModelsEntryFileResponseToJSONTyped,
} from './RevisdomAPIViewModelsEntryFileResponse';

/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1FileResponse
 */
export interface ApiResponse1FileResponse {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1FileResponse
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1FileResponse
     */
    message?: string | null;
    /**
     * 
     * @type {RevisdomAPIViewModelsEntryFileResponse}
     * @memberof ApiResponse1FileResponse
     */
    data?: RevisdomAPIViewModelsEntryFileResponse;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1FileResponse
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1FileResponse interface.
 */
export function instanceOfApiResponse1FileResponse(value: object): value is ApiResponse1FileResponse {
    return true;
}

export function ApiResponse1FileResponseFromJSON(json: any): ApiResponse1FileResponse {
    return ApiResponse1FileResponseFromJSONTyped(json, false);
}

export function ApiResponse1FileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1FileResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : RevisdomAPIViewModelsEntryFileResponseFromJSON(json['data']),
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1FileResponseToJSON(json: any): ApiResponse1FileResponse {
    return ApiResponse1FileResponseToJSONTyped(json, false);
}

export function ApiResponse1FileResponseToJSONTyped(value?: ApiResponse1FileResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': RevisdomAPIViewModelsEntryFileResponseToJSON(value['data']),
        'errors': value['errors'],
    };
}

